/**
 * Wait for the given time period
 * @param ts - time to wait in ms
 */
export const wait = (ts: number) => new Promise((resv) => setTimeout(resv, ts));

/**
 * Timer class represents a total timeout we can spread across multiple actions.
 * 1. const timeout = new Timer(1000)
 * 2. start -> timeout.next === 1000
 * 3. wait 500 ms -> timeout.next === 500
 * 4. wait 500 ms -> timeout.next === -1
 */
export class Timer {
  private value: number;
  private start?: number;
  constructor(value: number) {
    this.value = value;
  }

  /**
   * Call next to get the remaining timeout
   */
  public get next(): number {
    const now = Date.now();
    if (this.start) {
      const previousValue = this.value;
      const value = previousValue - (now - this.start);
      this.value = value > 0 ? value : -1;
    }
    this.start = now;
    return this.value;
  }
}

/**
 * Throw timeout error when promise timeout
 */
export function timeout<T>(ms: number, promise: Promise<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    const timeoutError = new Error('TIMEOUT');
    const timer = setTimeout(() => {
      reject(timeoutError);
    }, ms);

    promise
      .then((value) => {
        clearTimeout(timer);
        resolve(value);
      })
      .catch((reason) => {
        clearTimeout(timer);
        reject(reason);
      });
  });
}
